import { render, staticRenderFns } from "./remindCatComponent.vue?vue&type=template&id=4350026c&"
import script from "./remindCatComponent.vue?vue&type=script&lang=js&"
export * from "./remindCatComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports